(function () {
  if ( !window.DC) {
    window.DC = {};
  }

  var DC = window.DC;

  var Validation = DC.Validation = function (inputSelector, regex, errorSelector) {
    // Error check paramaters
    if(this._invalidParam(inputSelector) || this._invalidParam(regex) || this._invalidParam(errorSelector)) {
      console.log("Invalid parameters for validation");
      return undefined;
    }
    this.$inputSelector = $(inputSelector);
    this.regex = regex;
    this.$errorSelector = $(errorSelector);
  }

  Validation.prototype.valid = function() {
    return this.regex.test(this.$inputSelector.val());
  }

  Validation.prototype.validate = function() {
    this.valid() ? this.clearError() : this.renderError();
  }

  Validation.prototype.renderError = function() {
    this.$inputSelector.addClass("form-required");
    this.$errorSelector.addClass("form-error-active");
  }

  Validation.prototype.clearError = function() {
    this.$inputSelector.removeClass("form-required");
    this.$errorSelector.removeClass("form-error-active");
  }

  // Private Validation Functions
  Validation.prototype._invalidParam = function (param) {
    if(typeof(param) == "undefined") {
      return true;
    }
    return false;
  }

  // Form
  var Form = DC.Form = function() {
    this.validations = [];
  }

  Form.prototype.valid = function() {
    var valid = true;
    this._clearErrors();
    this.validations.forEach(function(validation) {
      if(!validation.valid()) {
        validation.renderError();
        valid = false;
      }
    });
    return valid;
  }

  Form.prototype.addValidation = function (inputSelector, regex, errorSelector) {
    var validation = new Validation(inputSelector, regex, errorSelector)
    if(typeof(validation) !== "undefined") {
      this.validations.push(validation);
      this._blurHandler(validation);
    }
  }

  // Private Form Functions
  Form.prototype._clearErrors = function () {
    $(".form-required").removeClass("form-required");
    $(".form-error-active").removeClass("form-error-active");
  }

  Form.prototype._blurHandler = function (validation) {
    input = validation.$inputSelector;
    input.on("blur", function(e) {
      validation.validate();
    });
  }
})();

// Render form in a selector specified via the data-target attribute
$(document).on("submit", ".js-load-on-submit", function(e) {
  e.preventDefault();

  var $form = $(this);
  var $target = $form;
  if ($form.data('target')) {
    $target = $($form.data('target'));
  }

  var xhr = $.ajax({
    url: $form.attr('action'),
    method: $form.attr('method') || 'POST',
    data: $form.serializeArray(),
  });
  xhr.done(function(data, textStatus, xhr) {
    $target.html(data);
  })
  xhr.fail(function(xhr, textStatus, errorThrown) {
    $target.html(xhr.responseText);
  });
});
